import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";

// import DetailIcon from "../assets/images/detail.svg";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
// import MedIcon from "../assets/mediation/mediation_icon.svg";
import Footer from "../Components/common/footer";
import TabsClient from "../Components/new-client-dashboard/Tabs";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
// import PropertyDamageTab from "../Components/Property-Damage/tabs/property-damage-tab";
// import MoreChangesTab from "../Components/new-client-dashboard/MoreChangesTab";
import AddEditPropertyDamage from "../Components/Property-Damage/tabs/modals/add-edit-property-damage";
import {
  fetchPageObject,
  fetchShakespeareStatus,
  getCaseId,
  getClientId,
  getToken,
} from "../Utils/helper";
import MediationTab from "../Components/mediation/MediationORSettleConf";
const PHOTO_ICON_URL =
  "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg";

const PageContent = ({ currentPage, mediations }) => {
  switch (currentPage) {
    case "mediation":
      return (
        <>
          <MediationTab mediations={mediations} settlementConferences={[]} />
        </>
      );
    case "photo":
      return <PhotoTab pageId={76} pageName={""} />;
    default:
      return null;
  }
};

function MediationORSettleConf() {
  // State management
  const [currentPage, setCurrentPage] = useState("mediation");
  //   const [viewType, setViewType] = useState("detail");
  const [showPropertyDamageModal, setShowPropertyDamageModal] = useState(false);
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const clientId = getClientId();
  const accessToken = getToken();
  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";
  const [pageObject, setPageObject] = useState(null);
  const [mediations, setMediations] = useState([]);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 76).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    if (!caseId || !clientId) return;
    const fetchRecords = async () => {
      try {
        const res = await axios.get(`${origin}/api/mediation/${caseId}/${clientId}/`, {
          params: { mediation_type: "mediation" },
          headers: { Authorization: accessToken },
        });
        setMediations(Array.isArray(res.data) ? res.data : [res.data]);
      } catch (error) {
        console.error("Error fetching mediation records:", error);
      }
    };
    fetchRecords();
  }, [caseId, clientId]);
  // Handlers
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  // Generate main tabs - each client, defendant, and party gets their own tab
  const mainTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "mediation",
      label: "Mediation",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("mediation"),
      leftHand: false,
    });

    return tabs;
  }, [handlePageChange]);

  //   const actionTabs = useMemo(
  //     () => [
  //       {
  //         id: "add-property-damage",
  //         label: "Property Damage",
  //         className: "tab-trapezium-cycles-corners",
  //         background: "var(--primary-50)",
  //         activeColor: "white",
  //         left: "0px",
  //         onClick: () => setShowPropertyDamageModal(true),
  //         leftHand: true,
  //         span: <span className="fw-bold p-r-5 text-gold">+</span>,
  //       },
  //     ],
  //     []
  //   );

  // Generate view tabs
  //   const viewTabs = useMemo(() => {
  //     const tabs = [];

  //     tabs.push({
  //       id: "detail",
  //       label: "Detailed",
  //       className:
  //         viewType === "detail"
  //           ? "active tab-trapezium-cycles-corners"
  //           : "tab-trapezium-cycles-corners",
  //       background: viewType === "detail" ? "var(--primary) !important" : "var(--primary-60)",
  //       activeColor: "white",
  //       onClick: () => {
  //         setViewType("detail");
  //       },
  //       leftHand: true,
  //       span: (
  //         <span className="fw-bold text-gold">
  //           <img src={DetailIcon} width="25" alt="Detail" />
  //         </span>
  //       ),
  //     });

  //     return tabs;
  //   }, []);

  // Generate photo tabs
  const photoTabs = useMemo(
    () => [
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span className="fw-bold text-gold p-r-5">
            <img
              src={PHOTO_ICON_URL}
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Photos"
              className="d-flex align-items-center justify-content-center"
            />
          </span>
        ),
      },
    ],
    [handlePageChange]
  );

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    // sending page ids directly now.
    fetchShakespeareStatus(caseId, 73, dispatch);
  }, [caseId, dispatch]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="76" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container overflow-hidden position-relative">
            <div className="d-flex flex-column w-100 position-absolute m-b-0" style={{ zIndex: 2 }}>
              <div className="d-flex align-items-center">
                <div style={{ minWidth: "90%", justifyContent: "flex-start" }}>
                  <NewChangesTabs
                    currentTab={currentPage}
                    tabsData={mainTabs}
                    height={25}
                    labelClass=" justify-content-start"
                  />
                </div>
                {/* <div style={{ minWidth: "25%", justifyContent: "center" }}>
                  <MoreChangesTab
                    currentTab={currentPage}
                    tabsData={actionTabs}
                    height={25}
                    popupTabs={true}
                    labelClass="ps-2 justify-content-start"
                  />
                </div>
                <div
                  style={{ minWidth: "20%", justifyContent: "flex-start" }}
                  className=" justify-content-start"
                >
                  <TreatmentTabs
                    handlePage={viewType}
                    tabsData={viewTabs}
                    height={25}
                    labelClass=" justify-content-start p-l-5"
                    forPage="Insurance"
                  />
                </div> */}

                <div style={{ width: "15%", position: "relative", right: "191px" }}>
                  <TabsClient
                    currentTab={currentPage}
                    tabsData={photoTabs}
                    height={25}
                    labelClass="p-l-5 p-r-5 justify-content-end"
                  />
                </div>
              </div>
              {/* <PageTitle currentPage={currentPage} /> */}
            </div>
            <div
              className="invisible-scrollbar h-100"
              style={{ overflowX: "hidden", overflowY: "scroll", marginTop: "25px" }}
            >
              <PageContent currentPage={currentPage} mediations={mediations} />
              <NotesSectionDashboard pageName={"Insurance"} />
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {showPropertyDamageModal && (
        <AddEditPropertyDamage
          show={showPropertyDamageModal}
          handleClose={() => setShowPropertyDamageModal(false)}
        />
      )}
    </>
  );
}

export default MediationORSettleConf;
